/**
 * @file index.js
 * @description Create all provider here and export them from index so that it can be imported from @/provider directly.
 * @version 0.0.1
 * Created at: 12/08/2025
 * Updated at: 12/08/2025
 */
import { Toaster } from '@/components';
import { ToastConfig } from '@/config';

import { ThemeProvider } from './theme-provider';

/**
 * This is a wrapper element for all Providers.
 */
export const Providers = async ({ children }) => {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      {children}
      <Toaster {...ToastConfig} />
    </ThemeProvider>
  );
};

export * from './permission-provider';

